import { useState, useRef, useEffect, useMemo } from "react";
import CefxLib from "../../helpers/CefxLib";
import { useLocation, useNavigate } from "react-router-dom";

import { NewSidebarCefx } from "./NewSideberCefx";
import { CefxComponent } from "./CefXComponent";
import { ViewImageComponent } from "./ViewImageComponent";
import { OpcoesProvider } from "./NewSideberCefx/OpcoesContext";

import CViewer3d from "./Viewer3d/CViewer3d";
import { NewSidebarView } from "./NewSidebarView";
import { ModalIa } from "./Modals/ModalIa/ModalIa";
import { ModalLoadingProcessIa } from "./Modals/ModalIa/ModalLoadingProcessIa/ModalLoadingProcessIa";
import { isJpnAndPngUtils } from "../../utils/fileTypes/isJpgAndPngUtils";
import { is3dTypeUtils } from "../../utils/fileTypes/is3dTypeUtils";
import { isDicomTypeUtils } from "../../utils/fileTypes/isDicomTypeUtils";
import { isVideoTypeUtils } from "../../utils/fileTypes/isVideoTypeUtils";

import { usePatientSearch } from "./usePatientSearch";
import styles from "./styles.module.css";

export function ViewImages() {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const imageParams = queryParams.get("image") || "";
  const tamanhoParams = queryParams.get("tamanho");

  // Custom hook for checking and fetching patient data
  const { patient, loading } = usePatientSearch();

  const [showModalIa, setShowModalIa] = useState(false);
  const [imageRotation, setImageRotation] = useState(0);
  const [image3d, setImage3d] = useState(false);
  const [modoCefXViewImage, setModoCefXViewImage] = useState(false);
  const [selectedImage, setSelectImage] = useState([]);
  const [theSelectImage, setTheSelectImage] = useState("");
  const [analysisSelected, setAnalysisSelected] = useState([]);
  const [textPont, setTextPonto] = useState("");
  const [getCollapse, setGetCollapse] = useState(false);
  const [pointNameOnTableClick, setPointNameOnTableClick] = useState({});
  
  const [isModalIaOpen, setIsModalIaOpen] = useState(false);
  const [isModalLoadingOpen, setIsModalLoadingOpen] = useState(false);

  // Derived state for images
  const pacienteAllImagensArray = useMemo(() => {
    return patient?.imagensPaciente?.filter(
      (imagem) =>
        imagem.link &&
        (isJpnAndPngUtils(imagem.link) || isVideoTypeUtils(imagem.link)) &&
        !imagem.link.includes("tomo_1")
    );
  }, [patient]);

  const pacientAllImagens3d = useMemo(() => {
    return patient?.imagensPaciente?.filter(
      (imagem) => imagem.link && is3dTypeUtils(imagem.link)
    );
  }, [patient]);

  /*---------- Handlers & Logic ---------*/

  const handleSelectedImage = (image) => {}; // Placeholder kept from original

  const handleModoCefXViewImage = (cefX) => setModoCefXViewImage(cefX);

  const getImagenRotation = (rotate) => setImageRotation(rotate);

  const handleChanceTheSelectedImage = (urlImage) => {
     setTheSelectImage(urlImage);
     const params = new URLSearchParams(location.search);
     params.set("image", urlImage);
     navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const handleGetNameEndCodAnalyze = (analysisSelected) => setAnalysisSelected(analysisSelected);
  const getTextPont = (textPonto) => setTextPonto(textPonto);
  const handleGetCollapse = (collapse) => setGetCollapse(collapse);
  const handlePontName = (pont) => setPointNameOnTableClick(pont);

  const closeModalIa = () => setIsModalIaOpen(false);
  const openModalIa = () => setIsModalIaOpen(true);
  const openModalLoading = () => setIsModalLoadingOpen(true);
  const closeModalLoading = () => setIsModalLoadingOpen(false);

  const handleLoadIa = () => {
    openModalLoading();
    ocefx.CarregarPontosIa(() => {
      closeModalLoading();
    });
    closeModalIa();
  };

  /*---------- Effects ---------*/

  useEffect(() => {
    if (showModalIa) openModalIa();
    else closeModalIa();
  }, [showModalIa]);

  useEffect(() => {
    if (
      (imageParams && is3dTypeUtils(imageParams)) ||
      (imageParams && isDicomTypeUtils(imageParams))
    ) {
      setImage3d(true);
    }
  }, [imageParams]);

  /*---------- Refs & Instances ---------*/
  
  const myViewer = useRef(new CViewer3d());
  const oViewer = myViewer.current;
  const [viwerActives, setViwerActives] = useState([]);

  const handleViwerActivesChange = (newViwerActives) => {
    setViwerActives(newViwerActives);
  };

  const myCefx = useRef(new CefxLib());
  const ocefx = myCefx.current;
  const [selectedImages, setSelectedImages] = useState();

  // Setup callbacks on mount
  useEffect(() => {
    ocefx.setMostrarModalIaCallback((value) => {
      setShowModalIa(value);
    });
  }, []); // Empty dependency array as ocefx is stable

  const selectedImageChange = (newCheckedImage) => {
    setSelectedImages(newCheckedImage);
  };

  return (
    <div className={styles.wrapper}>
      {!modoCefXViewImage && imageParams ? (
        <OpcoesProvider ocefx={ocefx}>
          <main className={styles.main}>
            <ViewImageComponent
              tamanhoParams={tamanhoParams}
              getCollapse={getCollapse}
              theSelectImage={theSelectImage}
              handleSelectedImage={handleSelectedImage}
              handleModoCefX={handleModoCefXViewImage}
              pacienteAllImagensArray={pacienteAllImagensArray}
              pacientAllImagens3d={pacientAllImagens3d}
              imageParams={imageParams}
              selectedImage={selectedImage}
              valueImageRotate={imageRotation}
              viwerActives={viwerActives}
              oViewer={oViewer}
              ocefx={ocefx}
              selectedImages={selectedImages}
              handleChanceTheSelectedImage={handleChanceTheSelectedImage}
            />
          </main>

          <NewSidebarView
            imageParams={imageParams}
            infoPaciente={patient}
            handleSelectedImage={handleSelectedImage}
            pacienteAllImagensArray={pacienteAllImagensArray}
            pacientAllImagens3d={pacientAllImagens3d}
            getImagenRotation={getImagenRotation}
            image3d={image3d}
            handleChanceTheSelectedImage={handleChanceTheSelectedImage}
            oViewer={oViewer}
            viwerActives={viwerActives}
            valueImageRotate={imageRotation}
            onViwerActivesChange={handleViwerActivesChange}
            selectedImageChange={selectedImageChange}
            ocefx={ocefx}
            handleGetCollapse={handleGetCollapse}
            theSelectImage={theSelectImage}
          />
        </OpcoesProvider>
      ) : (
        <OpcoesProvider ocefx={ocefx}>
          <main className={styles.main}>
            <CefxComponent
              infoPaciente={patient}
              handleModoCefX={() => {}}
              handleModoCefXViewImage={handleModoCefXViewImage}
              imageParams={imageParams}
              ocefx={ocefx}
              analysisSelected={analysisSelected}
              getTextPont={getTextPont}
              textPont={textPont}
              pointNameOnTableClick={pointNameOnTableClick}
              handleGetNameEndCodAnalyze={handleGetNameEndCodAnalyze}
            />
          </main>

          <NewSidebarCefx
            loadingPacientSearchCefx={loading}
            infoPaciente={patient}
            textPont={textPont}
            ocefx={ocefx}
            handleGetNameEndCodAnalyze={handleGetNameEndCodAnalyze}
            handlePontName={handlePontName}
          />
        </OpcoesProvider>
      )}

      <>
        {(isModalIaOpen || isModalLoadingOpen) && (
          <div className="react_modal_overlayIa" />
        )}

        {isModalIaOpen && (
          <ModalIa
            isOpen={isModalIaOpen}
            onRequestClose={closeModalIa}
            onLoadIa={handleLoadIa}
          />
        )}

        {isModalLoadingOpen && (
          <ModalLoadingProcessIa
            isOpen={isModalLoadingOpen}
            onRequestClose={closeModalLoading}
          />
        )}
      </>
    </div>
  );
}
